import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { ASSET_PATHS } from '@core/constants/assets.ts';

interface BackgroundImageProps extends BoxProps {
    variant?: 'login' | 'sidebar1' | 'none';
    overlay?: boolean;
    overlayColor?: string;
    overlayOpacity?: number;
}

export const BackgroundImage: React.FC<BackgroundImageProps> = ({
    variant = 'login',
    overlay = false,
    overlayColor = '#000000',
    overlayOpacity = 0,
    children,
    sx,
    ...props
}) => {
    const getBackgroundImage = () => {
        switch (variant) {
            case 'login':
                return ASSET_PATHS.backgrounds.login;
            case 'sidebar1':
                return ASSET_PATHS.backgrounds.sidebar.option1;
            case 'none':
                return null;
            // Other background variants can be added here
            default:
                return ASSET_PATHS.backgrounds.login;
        }
    };

    return (
        <Box
            sx={{
                position: 'relative',
                backgroundImage: getBackgroundImage() && `url(${getBackgroundImage()})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                ...(overlay && {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: overlayOpacity,
                        opacity: 0,
                        zIndex: 1
                    },
                    '& > *': {
                        position: 'relative',
                        zIndex: 2
                    }
                }),
                ...sx
            }}
            {...props}
        >
            {children}
        </Box>
    );
};
